import React from 'react';

import SearchContainer from '../../features/Search/Search';

const AdminSearchPage: React.FC = () => (
  <SearchContainer />
);

export default AdminSearchPage;
